import BaseRepository from "./base.repo";
import { HttpStatusCode } from "axios";

class SubscriptionRepository extends BaseRepository {
  async me(): Promise<{
    plan: { tier: string; name: string; price: number | null; period: string; tagline: string };
    limits: Record<string, number>;
    features: Record<string, boolean>;
    usage: Record<string, number>;
    hidden_modules: string[];
    subscription: {
      status: "active" | "expiring_soon" | "expired" | "none";
      name: string | null;
      end_date: string | null;
      days_remaining: number | null;
    };
  }> {
    const { data } = await this.client.get("/subscriptions/me");
    return data;
  }

  async getAll(params: any = {}) {
    const { data } = await this.client.get("/subscriptions", {
      params,
    });
    return data;
  }

  async getOne(id: number | string) {
    if (!id) return Promise.reject("ID is required");
    return this.client.get(`/subscriptions/${id}`);
  }

  async create(hotel: any) {
    let result = false;
    try {
      const response = await this.client.post("/subscriptions", {
        ...hotel,
      });
      if (response.status === HttpStatusCode.Created) {
        this.successToast("Subscription added successfully");
        result = true;
      }
    } finally {
      return result;
    }
  }

  async update(id: any, hotel: any) {
    let result = false;
    try {
      const response = await this.client.put(`/subscriptions/${id}`, hotel);
      if (response.status === HttpStatusCode.Ok) {
        this.successToast("Subscription payment initiated!");
        result = true;
      }
    } finally {
      return result;
    }
  }

  async subscribe(id: string, data: any) {
    try {
      const response = await this.client.post(`/subscriptions/${id}/subscribe`, data);
      if (response.status === HttpStatusCode.Created) {
        return response.data;
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message || error?.response?.data?.error || "Failed to subscribe to the subscription";
      this.errorToast(message);
      return null;
    }
  }

  async assign(id: string, data: { business_id: string; duration_months: number; reason: string }) {
    try {
      const response = await this.client.post(`/subscriptions/${id}/assign`, data);
      if (response.status === HttpStatusCode.Created) {
        this.successToast("Subscription assigned");
        return true;
      }
    } catch (error: any) {
      this.errorToast(error?.response?.data?.message || "Failed to assign subscription");
    }
    return false;
  }

  async unsubscribe(id: string, business_id: string) {
    let result = false;
    try {
      const response = await this.client.delete(`/subscriptions/${id}/unsubscribe/${business_id}`);
      if (response.status === HttpStatusCode.NoContent) {
        this.successToast("Subscription removed successfully");
        result = true;
      }
    } finally {
      return result;
    }
  }
}

export default SubscriptionRepository;
